const Footer = () => {
  const footer = document.querySelector(".footer");
  const screenWidth = window.innerWidth;

  if (footer) {
    const columns = [...footer.querySelectorAll(".footer__main-links-column")];

    columns.forEach((column) => {
      const title = column.querySelector(".nav-title");

      if (screenWidth < 768) {
        title.addEventListener("click", () => {
          const isAlreadyOpened = column.classList.contains("opened");

          columns.forEach((col) => {
            col.classList.remove("opened");
          });

          if (!isAlreadyOpened) {
            column.classList.add("opened");
          }
        });
      }
    });
  }
};

export default Footer;
